/* @flow weak */
export default function getRedirectLocationAfterGroupJoin(group) {
  return `/classes/${group.getCodeOrError()}/messages${group.canAddPeople() ? '?invite=true' : ''}`;
}
